import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
//redux
import { useNavigate, useParams } from "react-router-dom";
import { REMOVE_ITEM } from "helpers/api_endpoints";

const RemoveItem = () => {
    const params = useParams();
    const id = params.id;
    const navigate = useNavigate();

    useEffect(() => {
        del(REMOVE_ITEM, { id })
            .then(response => {
                navigate('/items', { state: { successMsg: response.data?.message || 'Item deleted Successfully' } });
            })
            .catch(error => {
                console.error("Error deleting item:", error);
                navigate('/items', { state: { errorMsg: error?.response?.data?.message || 'Failed to delete item' } });
            })
    });

    return <React.Fragment>Removing item...</React.Fragment>;
};

export default withRouter(RemoveItem);